import React, { Fragment } from 'react';
import strings from '../../../assets/localization';
import Alert from './Alert';
import Button from '../Button/Button';
import FakeBackground from '../../TopIndex/FakeBackground';

export const ErrorFallback = ({ error, resetErrorBoundary }) => {
  const reloadPage = () => {
    resetErrorBoundary();
    // location.reload();
  };

  // console.error('[ErrorFallback] caught:', error);
  // console.group('[ErrorBoundary]');
  // console.error(error);
  // console.error(error.stack);
  // console.groupEnd();

  return (
    <Fragment>
      <FakeBackground />
      <Alert>
        <h1>{strings.whoops}!</h1>
        <p>{strings.somethingWentWrong} ...</p>
        <Button clicked={reloadPage}>{strings.tryAgain}</Button>
      </Alert>
    </Fragment>
  );
};
